import { TagCloseTrigger, TagCloseTriggerProps } from '@chakra-ui/react';
import { forwardRef } from 'react';

/*
 * v2's `TagCloseButton` was named "close" (lowercase — kept verbatim so
 * existing selectors still match). v3's `Tag.CloseTrigger` sets no
 * `aria-label` and its default icon has no text alternative, leaving the
 * remove button unnamed. Callers can still override the label.
 */
const MTagCloseButton = forwardRef<HTMLButtonElement, TagCloseTriggerProps>(
  (props, ref) => <TagCloseTrigger ref={ref} aria-label="close" {...props} />,
);

MTagCloseButton.displayName = 'MTagCloseButton';

export default MTagCloseButton;
